var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { connect } from 'react-redux';
import * as React from 'react';
import { selectTreatmentValue, defaultGetSplitState } from '../selectors';
import { ON } from '../constants';
const NullRenderComponent = () => null;
/**
 * To avoid passing down dispatch property, merge props override default
 * behaviour from connect. Here dispatchProps are not passing down.
 *
 * @param {any} stateProps
 * @param {any} dispatchProps
 * @param {any} ownProps
 */
const mergeProps = (stateProps, dispatchProps, ownProps) => (Object.assign(Object.assign({}, stateProps), ownProps));
/**
 *  This toggler just returns a react component that decides which component to render
 * regarding it props.
 *
 * @param {React.ComponentType} ComponentOn
 * @param {React.ComponentType} ComponentDefault
 */
const toggler = (ComponentOn, ComponentDefault = NullRenderComponent) => (_a) => {
    var { isFeatureOn } = _a, props = __rest(_a, ["isFeatureOn"]);
    return isFeatureOn ? (React.createElement(ComponentOn, props)) : (React.createElement(ComponentDefault, props));
};
/**
 * Looks on the features of the Split piece of state, and maps to isFeatureOn
 * depending if this feature is ON or not
 *
 * @param {string} splitName split name
 * @param {SplitIO.SplitKey} key user key
 * @param {IGetSplitState} getSplitState function that extract the Split piece of state from the Redux state.
 */
export function mapIsFeatureOnToProps(splitName, key, getSplitState = defaultGetSplitState) {
    return (state) => {
        const splitState = getSplitState(state);
        return {
            isFeatureOn: selectTreatmentValue(splitState, splitName, key) === ON,
        };
    };
}
/**
 * Looks on the features of the Split piece of state, and maps to feature
 * the value of this feature
 *
 * @param {string} splitName split name
 * @param {SplitIO.SplitKey} key user key
 * @param {IGetSplitState} getSplitState function that extract the Split piece of state from the Redux state.
 */
export function mapTreatmentToProps(splitName, key, getSplitState = defaultGetSplitState) {
    return (state) => {
        const splitState = getSplitState(state);
        return {
            feature: selectTreatmentValue(splitState, splitName, key),
        };
    };
}
/**
 *
 * Returns a connected component that wraps the toggler
 * The idea of this is to send the isFeatureOn prop to the toggler
 *
 * So connect send the global state and the toggler decide which to render
 *
 * @param {string} splitName split name
 * @param {SplitIO.SplitKey} key user key
 * @param {IGetSplitState} getSplitState function that extract the Split piece of state from the Redux state.
 */
export function connectToggler(splitName, key, getSplitState = defaultGetSplitState) {
    return (ComponentOn, ComponentDefault) => connect(mapIsFeatureOnToProps(splitName, key, getSplitState), null, mergeProps, { pure: false })(toggler(ComponentOn, ComponentDefault));
}
